import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { TotalBudget } from "@/components/CampaignAnalytics";
import { P } from "@/components/ui/typography";
import { inboundCampaignsQueryOptions } from "@/lib/api";

export const Route = createFileRoute(
  "/app/_sidebar-layout/_campaigns-layout/campaigns/requests",
)({
  component: HomeComponent,
  loader: ({ context: { queryClient } }) => {
    void Promise.all([
      queryClient.prefetchQuery(inboundCampaignsQueryOptions()),
    ]);
  },
  head: () => ({ meta: [{ title: "Campaigns" }] }),
});

function HomeComponent() {
  const { data: inbound } = useSuspenseQuery(inboundCampaignsQueryOptions());

  const inboundRequests = inbound.filter(
    (item) => item.campaign_status.state === "proposed",
  );

  return (
    <>
      {inboundRequests.map((item) => {
        if (!item.campaign_status.algorithm) {
          return null;
        }

        return (
          <Link
            key={item.id}
            to="/app/campaigns/$campaignId/review/$algoId"
            params={{
              campaignId: item.id.toString(),
              algoId: item.campaign_status.algorithm.id.toString(),
            }}
            className="hover:bg-slate-2 dark:hover:bg-slatedark-2 p-4 text-left w-full not-last:border-b border-slate-6 dark:border-slatedark-6 flex flex-col gap-4 sm:flex-row justify-between items-start sm:items-center sm:gap-2"
          >
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <div className="h-4 w-4 bg-amber-10 dark:bg-amberdark-10 rounded-full shadow-xs" />
                <div className="font-semibold text-lg">{item.display_name}</div>
                <div className="rounded-md px-2 py-0.5 text-sm bg-slate-action text-slate-normal">
                  {item.campaign_status.algorithm.display_name}
                </div>
              </div>
              <div>
                {item.campaign_status.metadata?.reason ? (
                  <P>{item.campaign_status.metadata.reason}</P>
                ) : (
                  <span className="italic text-slate-dim">
                    No reason provided
                  </span>
                )}
              </div>
            </div>

            <div className="text-green-normal bg-green-action px-3 py-1 rounded-md">
              <TotalBudget status={item.campaign_status} />
            </div>
          </Link>
        );
      })}
    </>
  );
}
